<template>
    <div
        class="bulk-action-container"
        :class="{ 'normal-bulk-container': !actionsToDisplay.includes('batchAssign') }"
        v-if="selectedOrders.length"
    >
        <div class="bulk-text">
            {{ selectedOrders.length }} order{{ selectedOrders.length > 1 ? 's' : '' }} selected.
        </div>
        <div>
            <button
                v-if="actionsToDisplay.includes('sendSchedulingLink')"
                class="btn btn-send-sms"
                title="Send SMS"
                @click="sendSchedulingLink"
            >
                Send SMS
            </button>
            <button
                v-if="actionsToDisplay.includes('batchAssign')"
                class="btn"
                title="Batch Assign to Carrier"
                @click="handleBatchAssignClicked"
            >
                Batch Assign to Carrier
            </button>
        </div>
    </div>
</template>
<script>
import AssignOrderToCarrierModal from '@/pages/Orders/components/AssignOrderToCarrierModal';
import SendBulkSms from '../components/SendBulkSms';

export default {
    name: 'BulkOrderActions',
    props: {
        selectedOrders: {
            type: Array,
            required: true
        },
        /**
         * Props to control the visibility of the action buttons
         */
        actionsToDisplay: {
            type: Array,
            default: () => ['sendSchedulingLink'],
            validator(value) {
                const validActions = ['batchAssign', 'sendSchedulingLink', 'readyForPacking', 'bookNow'];
                return value.every((action) => validActions.includes(action));
            }
        }
    },
    methods: {
        sendSchedulingLink() {
            this.$modal
                .show(SendBulkSms, {
                    title: 'Send Bulk SMS',
                    selectedOrders: this.selectedOrders
                })
                .then((response) => {
                    if (response === 'ok') {
                        this.$modal.hide();
                    }
                });
        },
        async handleBatchAssignClicked() {
            await this.$modal
                .show(AssignOrderToCarrierModal, {
                    orderIds: this.selectedOrders.map((x) => x.orderId)
                })
                .then((response) => {
                    if (response === 'ok') {
                        this.params.context.componentParent.refreshServerSide();
                        this.$modal.hide();
                    } else {
                        this.$modal.hide();
                    }

                    this.$emit('carrier-assign', true);
                });
        }
    }
};
</script>

<style scoped lang="scss">
.bulk-action-container {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-bottom: 10px;
    background-color: #eee;
    border-radius: 6px;
    padding: 5px 10px;
    font-weight: 500;
    max-width: 500px;
    margin: -10px auto 10px auto;

    .bulk-text {
        margin-right: 30px;
    }

    .bulk-action-btn {
        font-size: 12px;
        margin: 0 3px;
        text-transform: initial;

        ::v-deep .md-ripple {
            padding: 3px 10px !important;
        }
    }
}
.table-bulk-action-container {
    .bulk-action-btn {
        width: 180px;
    }
}

.md-button-custom-ready-for-packing {
    background: #1c3e61 !important;
    color: #fff !important;
}

.btn {
    padding: 4px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
}
.btn:hover {
    background: #f5f5f5;
}

.btn-send-sms {
    margin-right: 5px;
}

.normal-bulk-container {
    background-color: #ddd;
}
</style>
